<template>
  <div class="relative">
    <PVSelect
      ref="navDropdown"
      v-bind="$attrs"
      v-model="selected"
      :placeholder="placeholder"
      :options="options"
      :aria-expanded="isOpen"
      pt:root:class="relative flex gap-1 items-center cursor-pointer select-none transition-all duration-200"
      pt:label:class="font-quicksand text-white font-normal outline-none transition-all duration-200"
      pt:overlay:class="bg-background-03 absolute !top-[82px] left-0 border border-gray-light-300 rounded-md rounded-tl-none shadow-lg"
      pt:list:class="p-0 list-none m-0"
      pt:listcontainer:class="!max-h-none before:content-[''] before:absolute before:-z-50 before:-top-2 before:left-2.5 before:bg-white before:w-6 before:h-6 before:rotate-45 before:rounded-[2px]"
      pt:option:class="p-0 rounded-md rounded-tl-none text-sm cursor-pointer select-none transition-all duration-200 focus:outline-none text-text-dark hover:bg-background-01"
      :pt="{
        label: ({ state, props }: any) => ({
          class: [
            state.focused || (activeOption && props.modelValue?.value == activeOption?.value)
              ? 'text-display-sm'
              : 'text-sm',
          ],
        }),
        dropdown: ({ state, props }: any) => ({
          class: [
            state.focused || (activeOption && props.modelValue?.value == activeOption?.value)
              ? 'rotate-180 text-black transition-all duration-200 size-4'
              : 'text-white',
          ],
        }),
        transition: {
          enterFromClass: 'opacity-0 scale-y-[0.8] text-accent-03',
          enterActiveClass:
            'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
          leaveActiveClass: 'transition-opacity duration-100 ease-linear',
          leaveToClass: 'opacity-0',
        },
      }"
      @change="handleChange"
      @focus="isOpen = true"
      @blur="isOpen = false"
    >
      <template #dropdownicon>
        <BaseIcon class="size-full" icon="ChevronDown"></BaseIcon>
      </template>
      <template #value="slotProps">
        <div class="flex items-center gap-2 overflow-hidden">
          <span
            class="truncate"
            :class="[
              activeOption && slotProps.value?.value == activeOption?.value
                ? 'text-display-sm'
                : 'text-sm',
            ]"
          >
            {{ slotProps.value ? slotProps.value.label : slotProps.placeholder }}
          </span>
        </div>
      </template>
      <template #option="slotProps">
        <div class="flex items-center justify-between gap-2 px-6 py-3">
          <div class="flex items-center gap-2">
            <p>
              {{ slotProps.option.label }}
            </p>
          </div>
          <BaseIcon v-if="slotProps.selected" class="size-5" icon="Check" />
        </div>
      </template>
    </PVSelect>
  </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from 'vue'
import { Select as PVSelect, type SelectEmitsOptions } from 'primevue'

import BaseIcon from '@/common/components/base/BaseIcon/BaseIcon.vue'
import { useEventListener } from '@vueuse/core'
import type {
  INavDropdown,
  INavDropdownOptions,
} from '@/features/navigation/components/NavDropdown/INavDropdown.ts'

const isOpen = ref(false)
const selected = defineModel<string | INavDropdownOptions>()
const emit = defineEmits<{
  (e: 'change', value: INavDropdownOptions): void
}>()

defineProps<INavDropdown>()

//#region when the dropdown is open, close it when the user scrolls
const navDropdown = useTemplateRef<SelectEmitsOptions>('navDropdown')

const closeDropdown = () => {
  if (navDropdown.value?.hide) {
    navDropdown.value.hide()
  }
}

const handleChange = (event: any) => {
  emit('change', event.value)
  window.location.href = event.value.value
}

useEventListener('scroll', closeDropdown, { passive: true })
//#endregion
</script>
